import { Injectable } from '@angular/core';
import { QueryConfig, QueryEntity } from '@datorama/akita';
import { isNotNullish } from '@y42/util/nullish';
import { combineLatest } from 'rxjs';
import { filter, map, pairwise } from 'rxjs/operators';
import { OrgState, OrgStoreModel, OrgUIModel } from '../models';
import { OrgStore } from './org.store';

@Injectable({ providedIn: 'root' })
@QueryConfig({ sortBy: (a: OrgStoreModel, b: OrgStoreModel) => a.name.localeCompare(b.name) })
export class OrgQuery extends QueryEntity<OrgState> {
  constructor(protected store: OrgStore) {
    super(store);
  }

  readonly orgs$ = this.selectAll();

  readonly activeOrg$ = this.selectActive().pipe(filter(isNotNullish));
  readonly active$ = this.selectActive();
  readonly activeOrgHasChanged$ = this.activeOrg$.pipe(
    pairwise(),
    map(([a, b]) => a && b && a.id !== b.id),
    filter(Boolean),
  );

  readonly joinableOrgs$ = combineLatest([this.orgs$, this.select((st) => st.ui.allJoinableOrgs)]).pipe(
    map(([orgs, allJoinableOrgs]) =>
      allJoinableOrgs.filter((joinableOrg) => !orgs.find((org) => org.id === joinableOrg.id)),
    ),
    map((joinableOrgs) => joinableOrgs.sort((a, b) => a.name.localeCompare(b.name))),
  );

  /** @deprecated not type-safe, use getActive instead */
  override getActiveId(): OrgStoreModel['id'] {
    return super.getActiveId() as OrgStoreModel['id'];
  }

  getActiveSlug(): OrgUIModel['slug'] | undefined {
    return this.getActive()?.slug;
  }
}
